// frontend/src/utils/categoryApi.js
import { apiFetch } from './api';

const ENDPOINT = '/categories';

/**
 * 階層型カテゴリを条件付きで全件取得するAPI
 */
export const getCategories = async () => {
  const res = await apiFetch(`${ENDPOINT}/`);
  if (!res.ok) throw new Error('ジャンル一覧の取得に失敗しました');
  return res.json();
};

/**
 * 新しいカテゴリ階層（大分類・中分類）を登録するAPI
 */
export const createCategory = async (data) => {
  const res = await apiFetch(`${ENDPOINT}/`, { method: 'POST', body: JSON.stringify(data) });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.detail || '登録に失敗しました');
  }
  return res.json();
};

/**
 * 既存のカテゴリ階層を修正するAPI
 */
export const updateCategory = async (uuid, data) => {
  const res = await apiFetch(`${ENDPOINT}/${uuid}`, { method: 'PUT', body: JSON.stringify(data) });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.detail || '更新に失敗しました');
  }
  return res.json();
};

/**
 * カテゴリ階層を削除するAPI
 */
export const deleteCategory = async (uuid) => {
  const res = await apiFetch(`${ENDPOINT}/${uuid}`, { method: 'DELETE' });
  if (!res.ok) throw new Error('削除に失敗しました。子データや商品が紐づいている可能性があります。');
};